<template>
  <div
    :class="[
      avatarColor
    ]"
    class="overflow-hidden leading-none flex items-center justify-center font-bold"
    aria-hidden="true"
  >
    <img v-if="image" :src="image" :alt="username" class="w-full h-full object-cover" />
    <span v-else>{{ userInitial }}</span>
  </div>
</template>
<script>
export default {
  name: 'AppAvatar',
  props: {
    username: {
      type: String,
      default: undefined
    },
    initials: {
      type: String,
      default: undefined
    },
    color: {
      type: String,
      default: undefined
    },
    image: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      colors: [
        'bg-primary-700 text-white', 'bg-primary-800 text-white', ' text-white bg-primary-900'
      ]
    }
  },
  computed: {
    avatarColor () {
      return this.color || this.randomColor(this.username.length, this.colors)
    },
    userInitial () {
      return this.initials || this.initial(this.username)
    }
  },
  methods: {
    initial (username) {
      const parts = username.split(/[ -]/)
      let initials = ''
      for (let i = 0; i < parts.length; i++) {
        initials += parts[i].charAt(0)
      }
      if (initials.length > 3 && initials.search(/[A-Z]/) !== -1) {
        initials = initials.replace(/[a-z]+/g, '')
      }
      initials = initials.substr(0, 3).toUpperCase()
      return initials
    },
    randomColor (seed, colors) {
      return colors[seed % (colors.length)]
    }
  }
}
</script>
